module.exports = __webpack_public_path__ + "img/purple.a0da5988.png";